module.exports = __webpack_public_path__ + "r-v3/img/plus.32dfe7f1.svg";